import Interceptor from 'auth/Interceptor'
import { API_BASE_URL } from 'configs/AppConfig';
import { initReactI18next } from 'react-i18next';
import { AUTH_TOKEN,USER_LOGED } from 'constants/AuthConstant';
import  secureLocalStorage  from  "react-secure-storage";

const AuthService = {}

async function setFetch(url,options)
{
	// Agregar timeout de 30 segundos
	const controller = new AbortController();
	const timeoutId = setTimeout(() => controller.abort(), 30000);
	
	const fetchOptions = {
		...options,
		signal: controller.signal
	};
	
	try {
		const response = await fetch(API_BASE_URL+url, fetchOptions);
		clearTimeout(timeoutId);
		const data = await response.json();
		return data;
	} catch (err) {
		clearTimeout(timeoutId);
		if (err.name === 'AbortError') {
			console.error('Request timeout');
			throw new Error('Request timeout - el servidor tardó demasiado en responder');
		}
		console.error('Fetch error:', err);
		throw err;
	}
}

AuthService.login = async function (data) {
	let token = '';
	
	try {
		const response = await fetch(API_BASE_URL+'/login', {
			method: 'post',
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			body: JSON.stringify(data),
			signal: AbortSignal.timeout(30000) // Timeout de 30 segundos
		});
		
		const resp = await response.json();
		
		if(resp.status === 'success') {
			token = resp.authorisation.token;
			secureLocalStorage.setItem(AUTH_TOKEN, token);
			let usuario = resp.user;
			secureLocalStorage.setItem(USER_LOGED, JSON.stringify(usuario));
		}
		else if(resp.status === 'error') {
			localStorage.setItem('errors', resp.message);
		}
		
		return token; // Retornar el token (string), no el objeto completo
		
	} catch (err) {
		let errorMessage = 'Error de conexión con el servidor';
		
		if (err.name === 'TimeoutError') {
			errorMessage = 'El servidor tardó demasiado en responder';
		}
		
		console.error('Login fetch error:', err);
		localStorage.setItem('errors', errorMessage);
		return ''; // Retornar string vacío en caso de error
	}

    return token;
}


AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data
	})
}

AuthService.logout = function () {
	return fetch({
		url: '/auth/logout',
		method: 'post'
	})
}

AuthService.loginInOAuth = function () {
	return fetch({
		url: '/auth/loginInOAuth',
		method: 'post'
	})
}

export default AuthService;